import { Container, Typography, Button } from '@mui/material';
import { styled } from '@mui/system';
import { useNavigate } from 'react-router-dom';

const StyledContainer = styled(Container)({
  backgroundColor: '#000',
  height: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 10,
});

const WhiteText = styled(Typography)({
  color: '#fff',
});

const NotFound = () => {
  const navigate = useNavigate();
  const handleButton = () => navigate('/');
  return (
    <StyledContainer>
      <div className='rounded-xl bg-neutral-900/80 p-8 z-20'>
        <WhiteText variant="h1">
          404
        </WhiteText>
        <WhiteText variant="h5">
          Page Not Found
        </WhiteText>
      </div>
      <Button variant="contained" color="primary" onClick={handleButton}>
        Go Back Home
      </Button>
    </StyledContainer>
  );
};

export default NotFound;
